import { useMemo } from 'react'
import { dataPipelines } from '../../../../api/coreData'

export default function usePipelineQuery (pipeline, variables, disableQuery = false) {
  const query = useMemo(() => {
    if (!pipeline) return null

    if (typeof pipeline === 'string') {
      return {
        pipelineCode: pipeline,
        variables: {
          // backwards compatability
          filters: (variables && 'filters' in variables) ? variables.filters : variables
        }
      }
    }

    return {
      pipeline: pipeline,
      variables
    }
  }, [pipeline, variables])

  const { data, isLoading, isFetching, error } = dataPipelines.useExecuteDataPipeline(query, { enabled: !disableQuery && !!query })

  return {
    data,
    isLoading,
    isFetching,
    error,
    enabled: !!query
  }
}
